import {FunctionComponent} from 'react';
import classNames from 'classnames';
import {Icon as LuffyIcon, IconProps as LuffyIconProps} from '@baidu/luffy-comp-icon';

import styles from './index.module.scss';


export enum IconSize {
    XXXS = 'xxxs',
    XXS = 'xxs',
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    LGX = 'lgx',
    LGXX = 'lgxx',
    XL = 'xl',
    XXL = 'xxl',
    XXXL = 'xxxl',
    XXXXL = 'xxxxl',
    LG_PROMAX = 'lgpromax',
    Auto = 'auto',
}

export interface IconProps extends LuffyIconProps {
    [key: string]: any;
    size?: IconSize;
    noSpace?: boolean;
}

export default function Icon(props: IconProps) {
    const {children, size = IconSize.MD, noSpace = false, className, ...iconProps} = props;
    const sizeClass = styles[size];
    const iconClassName = classNames(className, sizeClass, noSpace && styles.noSpace);
    return (
        <LuffyIcon className={iconClassName} {...iconProps}>
            {children}
        </LuffyIcon>
    );
}

export function addIcon(svg: FunctionComponent, size: IconSize) {
    return () => <Icon svg={svg} size={size} />;
}


